export const FORM_FIELD_CONSTRAINTS = {
  territoryId: { maxLength: 100 },
  companyName: { maxLength: 160 },
  legalForm: { maxLength: 32 },
  siret: { maxLength: 17, normalizedLength: 14, pattern: '[0-9\\s]{14,17}', inputMode: 'numeric' },
  vatNumber: { maxLength: 15, normalizedLength: 13, pattern: 'FR\\s?[A-Z0-9]{2}\\s?\\d{9}', inputMode: 'text' },
  address: { maxLength: 300 },
  displayName: { maxLength: 120 },
  representativeName: { maxLength: 160 },
  phone: { maxLength: 17, maxDigits: 10, inputMode: 'tel' },
  email: { maxLength: 254, inputMode: 'email' },
  professionalPhone: { maxLength: 17, maxDigits: 10, inputMode: 'tel' },
  joeDriverPhone: { maxLength: 17, maxDigits: 10, inputMode: 'tel' },
  circleDrivers: { maxLength: 1024, maxItems: 50 },
  pricePerKmTtc: { maxValue: 100, maxDecimals: 2, inputMode: 'decimal' },
  minimumPriceTtc: { maxValue: 10_000, maxDecimals: 2, inputMode: 'decimal' },
  partnerCommissionPercent: { maxValue: 100, maxDecimals: 2, inputMode: 'decimal' },
  minimumCommissionTtc: { maxValue: 10_000, maxDecimals: 2, inputMode: 'decimal' },
  paymentProvider: { maxLength: 32 },
  partnerPaymentUrl: { maxLength: 2048, inputMode: 'url' },
  certification: { maxLength: 1 },
} as const;

export type FormFieldKey = keyof typeof FORM_FIELD_CONSTRAINTS;
